// src/pages/battle/components/HostilesPanel.jsx
import React from 'react';
import { Skull } from 'lucide-react';
import { getColorClasses } from '../../themeConfig';

const HostilesPanel = ({ enemies, alertColor }) => {
  return (
    <div className={`bg-gray-800 border ${getColorClasses(alertColor, 'border')} rounded-lg p-4`}>
      <div className="flex items-center gap-2 mb-4">
        <Skull className={getColorClasses(alertColor)} size={20} />
        <h2 className="font-bold text-lg">HOSTILES</h2>
      </div>
      <div className="space-y-2">
        {enemies.map(a => (
          <div key={a.id} className="bg-gray-900/50 rounded p-2">
            <p className={`text-sm font-bold ${getColorClasses(alertColor)}`}>{a.name}</p>
            <div className="flex items-center justify-between text-xs mt-1">
              <span className="text-gray-400">HP: {a.hp}/{a.maxHp}</span>
              <span className="text-gray-400">AP: {a.ap}/{a.maxAp}</span>
            </div>
          </div>
        ))}
        {enemies.length === 0 && (
          <p className="text-sm text-gray-500 text-center py-4">All hostiles eliminated</p>
        )}
      </div>
    </div>
  );
};

export default HostilesPanel